import { render, staticRenderFns } from "./MonetaryEditDetails.vue?vue&type=template&id=997d2d66&scoped=true&"
import script from "./MonetaryEditDetails.vue?vue&type=script&lang=js&"
export * from "./MonetaryEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryEditDetails.vue?vue&type=style&index=0&id=997d2d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d2d66",
  null
  
)

export default component.exports